import React from 'react';
import { Snackbar, Alert, Button, IconButton, useTheme, alpha } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useGlobalError } from '../../context/GlobalErrorContext';

const GlobalNotificationBanner = () => {
    const { notification, clearNotification } = useGlobalError();
    const theme = useTheme();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        clearNotification();
    };

    const severity = notification?.severity || 'error';
    // Ensure we have a fallback color if the palette entry is missing, though standard ones should exist.
    const alertColor = theme.palette[severity]?.main || theme.palette.error.main;
    const contrastText = theme.palette.getContrastText(alertColor);

    const actionNode = (
        <React.Fragment>
            {notification?.action && (
                <Button 
                    variant="outlined" 
                    size="small" 
                    onClick={() => {
                        notification.action.onClick();
                        clearNotification();
                    }}
                    sx={{ 
                        color: contrastText, 
                        borderColor: contrastText,
                        '&:hover': {
                            borderColor: contrastText,
                            backgroundColor: alpha(theme.palette.common.white, 0.1)
                        },
                        mr: 1
                    }}
                >
                    {notification.action.label}
                </Button>
            )}
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Snackbar
            open={!!notification}
            autoHideDuration={notification?.severity === 'error' ? null : 6000} 
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 2000 }}
        >
            <Alert 
                onClose={handleClose} 
                severity={severity} 
                variant="filled"
                action={actionNode}
                sx={{ width: '100%', boxShadow: 3 }}
            >
                {notification?.message}
            </Alert>
        </Snackbar>
    );
};

export default GlobalNotificationBanner;
